export const signals = [
	{
		id: 1,
		name: 'Glovo',
		isActive: false,
	},
	{
		id: 2,
		name: 'Wolt',
		isActive: true,
	},
	{
		id: 3,
		name: 'Choco Food',
		isActive: true,
	}
];

export const restaurants = [
	{ id: "1rest", name: "Farsh Burger Abu Dhabi" },
	{ id: "2rest", name: "Salam Bro Abaya" },
];

export const languages = [ "ru", "en", "kk" ];